module.exports = __webpack_public_path__ + "res/img/avatatr_man.a18fd94b.png";